import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AnswerId, Answers, StepId } from './interfaces'

export type AnswersState = Partial<Record<StepId, { answerIds: Array<AnswerId>; prefilled: boolean; hidden: boolean }>>

const initialState: AnswersState = {}

export interface AddAnswerPayload {
  stepId: StepId
  answerIds: Array<AnswerId>
  hidden?: boolean
  prefilled?: boolean
}

export interface ClearAnswersPayload {
  ids: StepId[]
}

export const answersSlice = createSlice({
  name: 'answers',
  initialState,
  reducers: {
    addAnswer: (state: AnswersState, action: PayloadAction<AddAnswerPayload>) => {
      const { stepId, answerIds, hidden, prefilled = false } = action.payload
      state[stepId] = { answerIds, prefilled, hidden: !!hidden }
    },
    addPrefilledAnswers: (state: AnswersState, action: PayloadAction<Answers>) => {
      for (const [stepId, answerIds] of Object.entries(action.payload)) {
        state[stepId as StepId] = { answerIds, prefilled: true, hidden: false }
      }
    },
    clearAnswers: (state: AnswersState, action: PayloadAction<ClearAnswersPayload | undefined>) => {
      if (action.payload) {
        for (const stepId of action.payload.ids) {
          if (!state[stepId]?.prefilled) {
            delete state[stepId]
          }
        }
      } else {
        return {}
      }
    },
  },
})

export const { addAnswer, addPrefilledAnswers, clearAnswers } = answersSlice.actions
